import { render, staticRenderFns } from "./TenantProjectDocuments.vue?vue&type=template&id=dff3e54c&scoped=true&"
import script from "./TenantProjectDocuments.vue?vue&type=script&lang=js&"
export * from "./TenantProjectDocuments.vue?vue&type=script&lang=js&"
import style0 from "styles/tenants/submission-docs.scss?vue&type=style&index=0&id=dff3e54c&lang=scss&scoped=true&"
import style1 from "./TenantProjectDocuments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff3e54c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dff3e54c')) {
      api.createRecord('dff3e54c', component.options)
    } else {
      api.reload('dff3e54c', component.options)
    }
    module.hot.accept("./TenantProjectDocuments.vue?vue&type=template&id=dff3e54c&scoped=true&", function () {
      api.rerender('dff3e54c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/documents/TenantProjectDocuments.vue"
export default component.exports